/*
 * Trafford collection feature-block scroll animation.
 * Same counter-motion as the homepage editorial (trafford-editorial.js): as each
 * feature block passes through the viewport, the tall vertical image scales down
 * (1.15 -> 1.0) while the wide horizontal image scales up (1.0 -> 1.15), scrubbed
 * to scroll. Requires GSAP + ScrollTrigger (loaded in theme.liquid). No-op without
 * them, in the theme editor, or when the visitor prefers reduced motion.
 */
(function () {
  function setupBlock(block) {
    if (block.dataset.tCfeatInit === '1') return;
    var vert = block.querySelector('.twc-cfeat__vert .twc-cfeat__img');
    var horz = block.querySelector('.twc-cfeat__horz .twc-cfeat__img');
    if (!vert && !horz) return;

    var tl = window.gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
        invalidateOnRefresh: true
      }
    });
    if (vert) tl.fromTo(vert, { scale: 1.15 }, { scale: 1, ease: 'none' }, 0);
    if (horz) tl.fromTo(horz, { scale: 1 }, { scale: 1.15, ease: 'none' }, 0);

    block.dataset.tCfeatInit = '1';
  }

  function inEditor() {
    return window.Shopify && window.Shopify.designMode;
  }

  function init(root) {
    if (inEditor()) return;
    if (!window.gsap || !window.ScrollTrigger) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    (root || document).querySelectorAll('.twc-cfeat__block').forEach(setupBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    if (!inEditor() && window.ScrollTrigger) window.ScrollTrigger.refresh();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    if (!inEditor() && window.ScrollTrigger) window.ScrollTrigger.refresh();
  });
})();
